module.exports = __webpack_public_path__ + "media/icons/skrzynia-biegow-6c3b2e8f.png";